// BANNER
export const TITLE = <div>Training</div>;
export const SUB_TITLE = (
  <div>
    Take advantage of the invaluable training courses from Dynatrace University,
    or explore free courses created by the partner team.
  </div>
);
export const BUTTON_NAME = "Dynatrace University";
export const BUTTON_LINK = "https://university.dynatrace.com/";
export const SECOND_BUTTON_NAME = "Calendar";
export const SECOND_BUTTON_LINK = "#calendar";

// INSTRUCTIONS
export const SALES_TEXT =
  "Find and qualify new leads and research potential clients";
export const SALES_LINK =
  "https://partners.dynatrace.com/#/page/sales_enablement";
export const SALES_SPECIALIST_TEXT =
  "Create and develop sales strategies and craft proposals for potential clients";
export const SALES_SPECIALIST_LINK =
  "https://partners.dynatrace.com/#/page/sales_specialist";
export const SALES_ENGINEER_TEXT =
  "Plan and run technical live demos and proofs of concept/proofs of value";
export const SALES_ENGINNER_LINK =
  "https://partners.dynatrace.com/#/page/sales_engineer";
export const DELIVERY_CONSULTANT_TEXT =
  "Implement and deploy Dynatrace at scale with best-practices and provide consultancy services";
export const DELIVERY_CONSULTANT_LINK =
  "https://partners.dynatrace.com/#/page/delivery_consultant";

// BADGE
const SALES_COVER_1 = "Dynatrace positioning";
const SALES_COVER_2 = "Crushing the competition";
const SALES_COVER_3 = "Qualifying questions";
const SALES_COVER_4 = "Resources";
export const SALES_COVERS: String[] = [
  SALES_COVER_1,
  SALES_COVER_2,
  SALES_COVER_3,
  SALES_COVER_4,
];

// FAQs
export const TITLE_ONE =
  "What certifications are needed to be part of the Dynatrace partner program?";
export const TITLE_TWO = "Is there any certification for a Salesperson?";
export const TITLE_THREE =
  "What certifications are available for technical resources?";
export const TITLE_FOUR = "Can I get the certification exam for free?";

export const SUB_TITLE_ONE =
  "According to the Dynatrace Partner program, each Partner needs to have 2 Core Partner Training certifications (which can be done by sales, pre-sales or post-sales resources) and 2 Associate certifications (which are technical).";
export const SUB_TITLE_TWO =
  "Yes, the 'Core Partner' badge applies to Sales people. Just complete the “Core Partner Training”, and you will find a quiz at the end, which you will have to pass to gain the corresponding badge. This quiz can be done on your own, there is no need for a camera, and can be repeated if you do not achieve the needed grade.";
export const SUB_TITLE_THREE =
  "Our product certification program for Technical resources has 3 levels: Associate, Professional, and Master. More details on the different product certifications can be found on Dynatrace University.";
export const SUB_TITLE_FOUR =
  "The technical exams are proctored by an external company that monitors trainees throughout the exam via their webcam. The price of the exam is related to the cost of this exam proctoring. You can get a free exam voucher by completing all labs during the Dynatrace Associate Certification Bootcamp or by attending events like Perform and Amplify. On top of that, Dynatrace will fund the cost of a repeat exam for trainees that got more than 68% on their first paid exam attempt.";

// --
